<ng-container *ngIf="!gallery;else module">
  <ng-container *ngIf="mask == 'None';else withMask">
    <section *ngIf="!isInsideSlider" [ngClass]="dynamicClass" class="pb-m-banner-image pb-container">
      <ng-container *ngTemplateOutlet="module"></ng-container>
    </section>
    <ng-container *ngIf="isInsideSlider">
      <div class="pb-m-banner-image pb-container">
        <ng-container *ngTemplateOutlet="module"></ng-container>
      </div>
    </ng-container>
  </ng-container>
</ng-container>

<ng-template #module>
  <!-- pb--animate -->
    <div class="pb-c-banner-image pb-flex pb-flex-col lg:pb-items-center lg:pb-gap-x-8" [ngClass]="containerClass">
        <div class="lg:pb-w-1/2">
          <img *ngIf="!isMobile && data.image?.src" offset="100" [defaultImage]="'images/default-image.png' | asset" [lazyLoad]="data.image?.src" alt="{{data.image.alt}}" class="pb-h-full pb-max-h-[469px] pb-w-full xl:pb-max-w-[626px] pb-object-cover">
          <img *ngIf="isMobile && data.imagemobile?.src" offset="100" [defaultImage]="'images/default-image.png' | asset" [lazyLoad]="data.imagemobile?.src" alt="{{data.imagemobile.alt}}" class="pb-h-full pb-w-full xl:pb-max-w-[626px] pb-max-h-[268px]">
        </div>
        <!-- [ngClass]="{'pb-fadeInRight' : index % 2 == 0, 'pb-fadeInLeft' : index % 2 == 1}" -->
        <div
        class="pb-flex pb-flex-col lg:pb-w-1/2">
            <h3 data-title="true" class="pb-banner-title pb-text-h-md pb-text-color-brand pb-my-4 pb-font-serif lg:pb-text-d-lg">{{ data.title }}</h3>
            <p *ngIf="data?.subtitle" class="pb-text-md-m lg:pb-text-lg pb-mb-6"> {{ data.subtitle }} </p>
            <div *ngIf="data?.content != ''" class="!pb-text-lg-m lg:!pb-text-lg pb-article pb-article-piraeus" [innerHTML]="data?.content"></div>
            <a hybridHref hreflang="{{language}}" *ngIf="data?.link?.href" href="{{ data.link.href }}" class="pb-btn pb-text-md pb-mx-auto pb-w-full lg:pb-w-fit lg:pb-mx-0 pb-mt-6" [ngClass]="gallery && hasBackground?'pb-btn-primary':'pb-btn-secondary'">
                {{data?.link.text}} 
                <i *ngIf="data?.icon" class="pb-icon {{data?.icon}} pb-text-i-24 pb-icon-color-brand"></i>
            </a>
            
        </div>
    </div>
</ng-template>

<ng-template #withMask>
  <ng-container *ngIf="mask=='Simple';else withLogoMask">
    <section [ngClass]="dynamicClass" class="{{backgroundColorClass}}">
      <div class="pb-w-full pb-flex pb-gap-4 lg:pb-gap-6 pb-banner-image-mask" [ngClass]="containerClass">
              <div class="pb-flex pb-flex-col pb-justify-center pb-w-full pb-gap-4 lg:pb-gap-5 !pb-max-w-full lg:pb-w-5/12 !pb-mx-0" [ngClass]="containerPositionClass">
                  <h2 data-title="true" class="pb-text-d-xl-m xl:pb-text-d-xl pb-font-serif pb-text-color-brand">{{data.title}}</h2>
                  <div *ngIf="data?.subtitle != ''" class="lg:pb-text-lg">{{data.subtitle}}</div>
                  <div *ngIf="data?.content != ''" class="pb-text-lg-m lg:pb-text-lg pb-article pb-article-piraeus" [innerHTML]="data?.content"></div>
                  <div class="pb-flex pb-flex-col lg:pb-flex-row pb-gap-4 lg:pb-gap-5">
                      <a hybridHref hreflang="{{language}}" *ngIf="data?.link?.href" href="{{ data.link.href }}"  class="pb-btn pb-btn-primary pb-banner-btn">
                        {{ data?.link?.text }}
                        <i *ngIf="data?.icon" class="pb-icon {{data?.icon}} pb-text-i-24 pb-icon-color-brand"></i>
                      </a>
                      <a hybridHref hreflang="{{language}}" *ngIf="data?.secondarylink?.href" href="{{ data.secondarylink.href }}"  class="pb-btn pb-btn-secondary pb-banner-btn">
                        {{ data?.secondarylink?.text }}
                        <i *ngIf="data?.secondicon" class="pb-icon {{data?.secondicon}} pb-text-i-24 pb-icon-color-brand"></i>
                      </a>
                  </div>
              </div>
          <img *ngIf="!isMobile && data.image?.src" offset="100" [defaultImage]="'images/default-image.png' | asset" [lazyLoad]="data.image?.src" alt="{{ data.image?.alt }}" class="pb-h-full pb-object-cover pb-object-top pb-my-auto" [ngClass]="simpleMaskClass">
          <img *ngIf="isMobile && data.imagemobile?.src" offset="100" [defaultImage]="'images/default-image.png' | asset" [lazyLoad]="data.imagemobile?.src"  alt="{{ data.imagemobile?.alt }}" class="pb-h-full pb-object-cover pb-object-top" [ngClass]="simpleMaskClass">

      </div>
    </section>
  </ng-container>
</ng-template>

<ng-template #withLogoMask>
  <ng-container *ngIf="mask=='Logo';else withEmbeddedLogoMask">
    <section [ngClass]="dynamicClass">
      <div class="pb-container pb-w-full pb-flex pb-flex-col pb-gap-4 lg:pb-gap-6 pb-banner-image-mask" [ngClass]="containerClass">
        <div class="pb-flex pb-w-full pb-flex-col pb-justify-center pb-gap-4 lg:pb-gap-5 lg:pb-w-5/12">
          <h2 data-title="true" class="pb-text-d-xl-m lg:pb-text-d-xl pb-font-serif pb-text-color-brand">{{data.title}}</h2>
          <img offset="100" [defaultImage]="'images/default-image.png' | asset" [lazyLoad]="data.imagemobile?.src" *ngIf="isMobile && data.imagemobile?.src" alt="{{ data.imagemobile?.alt }}"  class="pb-block lg:pb-hidden pb-banner-mask-lines pb-h-full pb-object-cover pb-object-top" [ngClass]="LogoMaskClass">
          <ng-container *ngIf="rendering?.fields?.SliderItems?.length==0">
            <div class="lg:pb-text-lg">{{data.subtitle}}</div>
            <div *ngIf="data?.content != ''" class="pb-text-lg-m lg:pb-text-lg pb-article pb-article-piraeus" [innerHTML]="data?.content"></div>
            <div class="pb-flex pb-flex-col lg:pb-flex-row pb-gap-4 lg:pb-gap-5">
              <a hybridHref hreflang="{{language}}" *ngIf="data?.link?.href" href="{{ data.link.href }}" class="pb-btn pb-btn-primary pb-banner-btn">
                {{data?.link?.text }}
                <i *ngIf="data?.icon" class="pb-icon {{data?.icon}} pb-text-i-24 pb-icon-color-brand"></i>
              </a>
              <a hybridHref hreflang="{{language}}" *ngIf="data?.secondarylink?.href" href="{{ data.secondarylink.href }}"  class="pb-btn pb-btn-secondary pb-banner-btn">
                {{ data?.secondarylink?.text }}
                <i *ngIf="data?.secondicon" class="pb-icon {{data?.secondicon}} pb-text-i-24 pb-icon-color-brand"></i>
              </a>
            </div>
          </ng-container>
          <ng-container *ngIf="rendering?.fields?.SliderItems?.length>0">
            <div #SliderBannerImage class="swiper !pb-w-full lg:pb-mt-9">
              <div class="swiper-wrapper pb-pb-12">
                <div class="swiper-slide pb-w-full" *ngFor="let slide of rendering?.fields?.SliderItems">
                  <div data-title="true" class="pb-text-h-sm-m lg:pb-text-h-sm pb-font-bold pb-whitespace-pre-wrap pb-mb-6">{{slide?.fields?.Title?.value}}</div>
                  <p class="pb-text-lg-m lg:pb-text-lg ">{{slide?.fields?.Subtitle?.value}}</p>
                </div>
              </div>
              <div class="swiper-pagination !pb-text-center !pb-bottom-0"></div>
            </div>
          </ng-container>
        </div>
        <img *ngIf="!isMobile && data.image?.src" offset="100" [defaultImage]="'images/default-image.png' | asset" [lazyLoad]="data.image?.src" alt="{{ data.image?.alt }}" class="pb-hidden lg:pb-block pb-banner-mask-lines pb-h-full pb-object-cover pb-object-top pb-my-auto" [ngClass]="LogoMaskClass">
      </div>
    </section>
  </ng-container>
</ng-template>

<ng-template #withEmbeddedLogoMask>
  <section [ngClass]="dynamicClass">
    <div class="pb-container pb-w-full pb-flex pb-flex-col-reverse lg:pb-flex-row pb-gap-4 lg:pb-gap-14" [ngClass]="containerClass">
        <div class="pb-flex pb-flex-col pb-w-full pb-justify-center pb-gap-4 lg:pb-gap-5 lg:pb-w-5/12">
            <h2 data-title="true" class="pb-text-d-xl pb-font-serif pb-text-color-brand">{{data.title}}</h2>
            <ng-container *ngif="rendering?.fields?.SliderItems?.length == 0">
              <div class="pb-text-lg">{{data.subtitle}}</div>
              <div *ngIf="data?.content != ''" class="pb-text-lg-m lg:pb-text-lg pb-article pb-article-piraeus" [innerHTML]="data?.content"></div>
              <div class="pb-flex pb-flex-col lg:pb-flex-row pb-gap-4 lg:pb-gap-5">
                  <a hybridHref hreflang="{{language}}" *ngIf="data?.link?.href" href="{{ data.link.href }}" class="pb-btn pb-btn-primary pb-banner-btn">
                    {{data?.link?.text }}
                    <i *ngIf="data?.icon" class="pb-icon {{data?.icon}} pb-text-i-24 pb-icon-color-brand"></i>
                  </a>
                  <a hybridHref hreflang="{{language}}" *ngIf="data?.secondarylink?.href" href="{{ data.secondarylink.href }}"  class="pb-btn pb-btn-secondary pb-banner-btn">
                    {{ data?.secondarylink?.text }}
                    <i *ngIf="data?.secondicon" class="pb-icon {{data?.secondicon}} pb-text-i-24 pb-icon-color-brand"></i>
                  </a>
              </div>
            </ng-container>
            <ng-container *ngIf="rendering?.fields?.SliderItems?.length>0">
              <div #SliderBannerImage class="swiper lg:pb-mt-9">
                <div class="swiper-wrapper pb-pb-12">
                  <div class="swiper-slide" *ngFor="let slide of rendering?.fields?.SliderItems">
                    <div data-title="true" class="pb-text-h-sm-m lg:pb-text-h-sm pb-font-bold pb-whitespace-pre-wrap pb-mb-6">{{slide?.fields?.Title?.value}}</div>
                    <p class="pb-text-lg-m lg:pb-text-lg ">{{slide?.fields?.Subtitle?.value}}</p>
                  </div>
                </div>
                <div class="swiper-pagination !pb-text-center !pb-bottom-0"></div>
              </div>
            </ng-container>
        </div>
        <img *ngIf="data.image?.src" offset="100" [defaultImage]="'images/default-image.png' | asset" [lazyLoad]="data.image?.src" alt="{{ data.image?.alt }}" class="lg:pb-w-1/2 pb-h-full pb-object-cover pb-object-top pb-my-auto" [ngClass]="LogoMaskClass">
    </div>
  </section>
</ng-template>